export default class Combo {
  constructor(
    id,
    isVisible,
    comboSource,
    contentSource,
    articles,
    position,
    orderedByAvailability,
  ) {
    this.id = id;
    this.isVisible = isVisible;
    this.comboSource = comboSource;
    this.contentSource = contentSource;
    this.articles = articles;
    this.position = position;
    this.orderedByAvailability = orderedByAvailability;
  }

  getLoadTrackingPayloadForParent(parentId) {
    return {
      id: `${parentId}-Combo${this.position}`,
      parentId,
      name: "ComboListDetail-Tile",
      position: this.position,
      status: "loaded",
      labels: {
        promo_Content: [this.id],
        promo_ComboSource: [this.comboSource],
        promo_Source: [this.contentSource],
      },
    };
  }

  getVisibleTrackingPayloadForParent(parentId) {
    return {
      id: `${parentId}-Combo${this.position}`,
      parentId,
      name: "ComboListDetail-Tile",
      position: this.position,
      status: "visible",
      labels: {
        promo_Content: [this.id],
        promo_ComboSource: [this.comboSource],
        promo_Source: [this.contentSource],
      },
    };
  }

  getFeatureIdPayloadForParent(parentId) {
    return {
      featureId: `${parentId}-Combo${this.position}`,
    };
  }

  getClickTrackingPayloadForParent(parentId) {
    return {
      id: `${parentId}-Combo${this.position}`,
      parentId,
      name: "ComboListDetail-Tile",
      position: this.position,
      status: "clicked",
      labels: {
        promo_Content: [this.id],
        promo_ComboSource: [this.comboSource],
        promo_Source: [this.contentSource],
      },
    };
  }

  hasSoldOutArticles() {
    return this.articles.some(
      (article) =>
        article.availability != null && article.availability === "SOLDOUT",
    );
  }
}
